const REVIEWS_EVENT_ID = "reviews.drawer.open";
const REVIEW_SNIPPET_ID = "pr-review-snippet";
export {
  REVIEWS_EVENT_ID,
  REVIEW_SNIPPET_ID
};
//# sourceMappingURL=constants.js.map
